import { useEffect, useState } from "react";

// Documents a staff member has opened during the current login session, so the lists can
// tint them. Kept in localStorage (shared by all tabs) and cleared on login, logout and
// session timeout (see AuthContext).
const KEY = "penda_opened_docs";
const CHANGED = "penda:opened-docs-changed";

const read = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY)) || []);
  } catch {
    return new Set();
  }
};

const notify = () => window.dispatchEvent(new Event(CHANGED));

export function markOpened(storagePath) {
  const opened = read();
  if (opened.has(storagePath)) return;
  opened.add(storagePath);
  try {
    localStorage.setItem(KEY, JSON.stringify([...opened]));
  } catch {
    // storage unavailable: the tint just won't show
  }
  notify();
}

export function clearOpened() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  notify();
}

export function useOpenedDocs() {
  const [opened, setOpened] = useState(read);
  useEffect(() => {
    const update = () => setOpened(read());
    const onStorage = (e) => e.key === KEY && update();  // other tabs
    window.addEventListener(CHANGED, update);
    window.addEventListener("storage", onStorage);
    return () => { window.removeEventListener(CHANGED, update); window.removeEventListener("storage", onStorage); };
  }, []);
  return opened;
}
